export const CLIENT_DOCUMENTS_QUERY_KEY = 'clientDocuments'
export const BRIEF_CLIENT_DOCUMENTS_QUERY_KEY = 'briefClientDocuments'
